window.addEventListener("load", async function () {
  if (!location.href.includes("/products")) {
    return;
  }
  let currentSizeUnit;
  let currentSizeUnitIndex;

  await buildSizeGuide();
  document.querySelectorAll(".unit-sel-btn").forEach((btn) => {
    btn.addEventListener("click", changeCurrentUnit);
  });
  buildUnitSelectorVariants();
});

let productType = "";
let productMeassure = "";
// ------------size guide
async function buildSizeGuide() {
  findProductType();

  //if no product type end
  if (productType == "") {
    return;
  }
  findMeassure();

  buildTable();
  hideColumn("INCHES");
  document.querySelector(".size_guide_outer_wrap").style.display = "flex";

  return;
}

function buildTable() {
  for (key in sizeGuideData) {
    //Find the size guide data corresponding to the product type
    if (key.toUpperCase() == productType) {
      const sizeGuide = sizeGuideData[key];
      let sizeTableBody = "";
      let sizeTableHead = "";
      for (key in sizeGuide) {
        // Find headers and unit selector btns for this size guide - each key is a row
        const units = sizeGuide[key];
        if (key.includes("Input")) {
          const unitSelectorParent = document.querySelector(".size-table__unit-selector");
          const allowedBtns = ["INCHES", "CM"];
          let unitSelectorContent = "";
          let selector = "";
          for (let i = 1; i < units.length; i++) {
            let headerTag = "<th>" + units[i] + "</th>";
            for (btn in allowedBtns) {
              if (units[i].includes(allowedBtns[btn])) {
                if (units[i].toUpperCase().includes("CM")) {
                  selector = "<div class='unit-sel-btn CM'>CM</div>";
                } else if (units[i].toUpperCase().includes("INCHES")) {
                  selector = "<div class='unit-sel-btn INCHES'>INCHES</div>";
                }
                headerTag = "<th>" + productMeassure + " (" + units[i] + ")" + "</th>";
                unitSelectorContent = unitSelectorContent + selector;
              }
            }
            sizeTableHead = sizeTableHead + headerTag;
          }
          unitSelectorParent.innerHTML = unitSelectorContent;
          if (document.querySelector(".size-table__unit-selector").innerHTML != "") {
            document.querySelector(".unit-sel-btn.INCHES").dataset.active = false;
            document.querySelector(".unit-sel-btn.CM").dataset.active = true;
          }
        } else {
          // build size table
          sizeTableBody = sizeTableBody + "<tr>";
          for (let i = 1; i < sizeGuide[key].length; i++) {
            const sizeTag = "<td>" + sizeGuide[key][i] + "</td>";
            sizeTableBody = sizeTableBody + sizeTag;
          }
          sizeTableBody = sizeTableBody + "</tr>";
        }
      }
      const sizeTable = "<table>" + sizeTableHead + sizeTableBody + "</table>";
      const sizeTableParent = document.querySelector(".product-modal .size-table");
      sizeTableParent.innerHTML = sizeTable;
      return sizeTable;
    }
  }
}

function findProductType() {
  //find product type - check metafield
  if (typeof metafieldProductType === "string" && metafieldProductType != "") {
    productType = metafieldProductType.toUpperCase();
    return productType;
  } else {
    //find product type - check tags
    const loopLength = Object.keys(sizeGuideData).length;
    for (let i = 0; i < loopLength; i++) {
      const type = Object.keys(sizeGuideData)[i].toUpperCase();
      if (productTags.toUpperCase().includes(type)) {
        productType = type;
        return productType;
      }
    }
  }
}

function changeCurrentUnit() {
  const showColumn = event.target.textContent;
  if (showColumn == "INCHES") {
    document.querySelector(".unit-sel-btn.INCHES").dataset.active = true;
    document.querySelector(".unit-sel-btn.CM").dataset.active = false;
    hideColumn("CM");
  } else if (showColumn == "CM") {
    hideColumn("INCHES");
    document.querySelector(".unit-sel-btn.INCHES").dataset.active = false;
    document.querySelector(".unit-sel-btn.CM").dataset.active = true;
  }
}

function findMeassure() {
  const productTypeLowerCase = productType.toLowerCase();
  if (!measureTitles) return;
  productMeassure = measureTitles[productTypeLowerCase];
}

function findIndex(unit) {
  const productTypeLowerCase = productType.toLowerCase().trim();

  const index = sizeGuideData[productTypeLowerCase]?.Input_SIZE?.indexOf(unit);
  return index;
}

function hideColumn(unit) {
  const table = document.querySelector(".product-modal .size-table table");
  let index = findIndex(unit);
  const classname = "hide-col-" + index;
  table.removeAttribute("class");
  table.classList.add(classname);
}

function buildUnitSelectorVariants() {
  for (key in sizeGuideData) {
    if (key.toUpperCase() == productType) {
      const sizeGuide = sizeGuideData[key];
      const sizeUnitWrapper = document.querySelector(".size_unit_selectors");
      let selectors = "";
      for (key in sizeGuide) {
        const units = sizeGuide[key];
        if (key.includes("Input")) {
          for (let i = 1; i < units.length; i++) {
            let item = "";
            if (i == 1) {
              currentSizeUnit = units[i];
              currentSizeUnitIndex = 1;
              changeVariantBtnText();
              item = "<span data-index='" + i + "' class='unit_selector selected " + units[i] + "'>" + units[i] + "</span>";
            } else {
              item = "<span data-index='" + i + "' class='unit_selector " + units[i] + "'>" + units[i] + "</span>";
            }
            selectors = selectors + item;
          }
        }
      }
      sizeUnitWrapper.innerHTML = selectors;
    }
  }
  document.querySelectorAll(".size_unit_selectors .unit_selector").forEach((selector) => {
    selector.addEventListener("click", changeCurrentSizeUnit);
  });
}

function changeCurrentSizeUnit() {
  currentSizeUnit = this.innerText;
  document.querySelectorAll(".size_unit_selectors .unit_selector").forEach((selector) => {
    selector.classList.remove("selected");
    if (selector.innerText == currentSizeUnit) {
      currentSizeUnitIndex = selector.dataset.index;
      selector.classList.add("selected");
    }
  });
  changeVariantBtnText();
}

function changeVariantBtnText() {
  const sizeGuide = sizeGuideData[productType.toLowerCase()];
  const optionName = document.querySelector(".radio__legend__option-name").innerText.replaceAll("ø", "o").replaceAll("æ", "ae").replaceAll("å", "a").replaceAll("ß", "ss").replaceAll("ö", "o").replaceAll("ä", "a").toLowerCase();

  document.querySelectorAll(".product__selectors .radio__button label").forEach((label) => {
    const forValue = label.attributes.for.value.replaceAll("-", "");
    const index = forValue.indexOf(optionName) + optionName.length;
    const forSizes = forValue.slice(index);

    for (key in sizeGuide) {
      const cleanKey = key.replaceAll("-", "").replaceAll(" ", "").replaceAll("ø", "o").replaceAll("æ", "ae").replaceAll("å", "a").replaceAll(".", "").replaceAll("é", "e");

      if (key != "" && forSizes.toUpperCase().includes(cleanKey.toUpperCase())) {
        const newText = sizeGuide[key][currentSizeUnitIndex];
        label.querySelector("span").innerText = newText;
      }
    }
  });
}
